import { CheckCheck } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { ApprovalsView } from "./ApprovalsView";

export function ApprovalsPage() {
  return (
    <div>
      <PageHeader
        icon={CheckCheck}
        title="Post Approvals"
        description="Review, approve, or reject posts submitted by your team before they go live. Posts awaiting approval appear here in the order they were submitted."
      />
      <ApprovalsView showHeader={false} />
    </div>
  );
}
